import { useEffect, useState } from "react";

export function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    if (typeof localStorage !== "undefined") {
      const storedData = localStorage.getItem(key);
      try {
        return storedData ? JSON.parse(storedData) : initialValue;
      } catch (error) {
        console.error(`Error reading ${key} from local storage:`, error);
        return initialValue;
      }
    }
    return initialValue;
  });

  useEffect(
    function () {
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          console.error(`Error writing to local storage:`, error);
        }
      }
    },
    [key, value]
  );

  return [value, setValue];
}
